var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.724136 8.55805C0.792923 8.38064 0.896065 8.21857 1.02764 8.08112L8.25391 0.854847C8.38866 0.720093 8.54864 0.613202 8.7247 0.540274C8.90077 0.467346 9.08947 0.42981 9.28004 0.42981C9.66491 0.42981 10.034 0.5827 10.3062 0.854847C10.4409 0.9896 10.5478 1.14958 10.6207 1.32564C10.6937 1.5017 10.7312 1.69041 10.7312 1.88098C10.7312 2.26585 10.5783 2.63496 10.3062 2.90711L5.53683 7.66199H18.3626C18.7459 7.66199 19.1135 7.81426 19.3846 8.0853C19.6556 8.35634 19.8079 8.72394 19.8079 9.10725C19.8079 9.49055 19.6556 9.85816 19.3846 10.1292C19.1135 10.4002 18.7459 10.5525 18.3626 10.5525H5.53683L10.3062 15.3074C10.4416 15.4417 10.5491 15.6016 10.6225 15.7777C10.6959 15.9538 10.7337 16.1427 10.7337 16.3335C10.7337 16.5243 10.6959 16.7132 10.6225 16.8893C10.5491 17.0654 10.4416 17.2253 10.3062 17.3596C10.1718 17.4951 10.012 17.6026 9.83585 17.676C9.65973 17.7494 9.47083 17.7872 9.28004 17.7872C9.08925 17.7872 8.90035 17.7494 8.72423 17.676C8.54811 17.6026 8.38827 17.4951 8.25391 17.3596L1.02764 10.1334C0.896065 9.99593 0.792923 9.83385 0.724136 9.65644C0.579584 9.30458 0.579584 8.90991 0.724136 8.55805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/left arrow.ad173c59ac72f8c120f2baa3d61adbb7.svg";
export { ForwardRef as ReactComponent };